import { Hangar, Tenant } from "../types";

/**
 * Check if a hangar is a sandbox (private training hangar)
 */
export const isSandboxHangar = (hangar: Hangar): boolean => {
  return hangar.owner_user_id != null;
};

/**
 * Check if a hangar is a public FBO hangar (not a sandbox)
 */
export const isPublicHangar = (hangar: Hangar): boolean => {
  return hangar.owner_user_id == null;
};

/**
 * Filter out sandbox hangars from a list
 * Useful for official features like multi-hangar, reports, printing
 */
export const filterOutSandboxHangars = (hangars: Hangar[]): Hangar[] => {
  return hangars.filter(isPublicHangar);
};

/**
 * Get only sandbox hangars from a list
 */
export const filterSandboxHangars = (hangars: Hangar[]): Hangar[] => {
  return hangars.filter(isSandboxHangar);
};

/**
 * Check if a tenant is a sandbox tenant (only exists in a sandbox)
 */
export const isSandboxTenant = (tenant: Tenant): boolean => {
  return tenant.sandbox_hangar_id != null;
};

/**
 * Check if a tenant is a real FBO tenant (not a sandbox tenant)
 */
export const isRealTenant = (tenant: Tenant): boolean => {
  return tenant.sandbox_hangar_id == null;
};

/**
 * Filter out sandbox tenants from a list
 */
export const filterOutSandboxTenants = (tenants: Tenant[]): Tenant[] => {
  return tenants.filter(isRealTenant);
};
